import {useTranslation} from 'react-i18next';
import ChekinProSettings from '../../ChekinProSettings';
import {GIGSKY_LINK} from './constants';
import {BannerLink, Banner, Content, Title, Subtitle, Price} from './styled';

import bigBgImage from './assets/train-with-phone-bg-big.png';
import bgImage from './assets/train-with-phone-bg.png';
import logo from './assets/gigsky-logo.png';

export function GigSkyBanner() {
  const {t} = useTranslation();

  if (ChekinProSettings.isSDK) {
    return null;
  }

  return (
    <BannerLink href={GIGSKY_LINK} target="_blank">
      <Banner $bigBgImage={bigBgImage} $bgImage={bgImage}>
        <Content>
          <Title>
            {t('gigsky.connect_with_gigsky')}{' '}
            <img
              className={'logo'}
              src={logo}
              alt="gigsky-logo"
              width={104}
              height={19}
            />
          </Title>
          <Subtitle>{t('gigsky.travel_peacefully')}</Subtitle>
          <Price>{t('gigsky.starting_price')}</Price>
        </Content>
      </Banner>
    </BannerLink>
  );
}
